import { Col, Row, Image, Alert, Divider } from 'antd';
import Title from 'antd/lib/typography/Title';
import React from 'react';
import { Company } from '../../../models/company-interface';
import { Subscription } from '../../../models/subscription-interface';

interface SubscriptionProps {
  companyDetails: Company | undefined;
  companyLogo: string | undefined;
  subscription: Subscription | undefined;
  isLoading: boolean;
}

export default function SubscriptionDisplay({
  companyDetails,
  companyLogo,
  subscription,
  isLoading,
}: SubscriptionProps) {
  if (!companyDetails || !subscription) return null;

  return (
    <>
      <Row style={{ textAlign: 'center' }}>
        <Col span={24}>
          {!!companyLogo?.length && (
            <Image
              className='contributor-page-company-logo'
              alt={
                companyDetails.name === '' ? '' : `${companyDetails.name} logo`
              }
              src={companyLogo}
              preview={false}
              style={{ maxWidth: '100%' }}
            />
          )}
          <Title className='primary-text' level={3}>{companyDetails.name}</Title>
          {companyDetails.isDemoCompany && (
            <Alert
              type='warning'
              message='This is a demo company'
              style={{ marginBottom: 16 }}
            />
          )}
          {!!companyDetails.baseProduct && (
            <b>
              {companyDetails.baseProduct.product?.name} -{' '}
              {companyDetails.baseProduct.ratePlanName}
            </b>
          )}
          <br />
          <SubscriptionDates
            companyDetails={companyDetails}
            subscription={subscription}
            isLoading={isLoading}
          />
          <div>
            <span style={{ color: '#212529' }}>Account</span>{' '}
            <b>#{companyDetails.id}</b>
          </div>
        </Col>
      </Row>
      <Divider style={{ marginTop: 16, marginBottom: 16 }} />
    </>
  );
}

const SubscriptionDates = ({
  companyDetails,
  subscription,
  isLoading,
}: {
  companyDetails: Company | undefined;
  subscription: Subscription | undefined;
  isLoading: boolean;
}) => {
  if (isLoading) return null;
  if (!companyDetails) return <i>No Subscription</i>;

  if (
    !!subscription &&
    !!subscription.plans.find(x => x.isBaseProduct) &&
    !!subscription.plans.find(x => x.isBaseProduct)?.contractEffectiveDate &&
    !!subscription.plans.find(x => x.isBaseProduct)?.expirationDate
  ) {
    const effectiveDate = new Date(
      subscription.plans.find(x => x.isBaseProduct)?.contractEffectiveDate ?? new Date()
    ).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
    const expirationDate = new Date(
      subscription.plans.find(x => x.isBaseProduct)?.expirationDate ?? new Date()
    ).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
    return (
      <>
        <b>Effective {effectiveDate}</b>
        <br />
        <i>Expires {expirationDate}</i>
      </>
    );
  }

  if (
    !!companyDetails.subscriptionExpirationDate &&
    !!companyDetails.baseProduct
  ) {
    const expirationDate = new Date(
      companyDetails.subscriptionExpirationDate
    ).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
    return <i>Expires {expirationDate}</i>;
  }

  if (!subscription && !isLoading) {
    return <i>No Subscription</i>;
  }

  return null;
};
